import api from './api';
import { getStudioHandoffUrl } from '../config/studio';
import { reportError } from '../lib/errorManager';
import { paintStudioRedirectShell } from '../lib/studioRedirectShell';
import { markAcademyAuthResync } from '../lib/academyAuthResync';

export type StudioLaunchStep = 'workspace' | 'open';

export type StudioLaunchResult =
  | { ok: true; handoffToken: string }
  | { ok: false; message: string };

/** Obtain a short-lived handoff token to establish a Labs session in Studio. */
export async function launchStudioWorkspace(): Promise<StudioLaunchResult> {
  try {
    const response = await api.post<{
      status: string;
      data?: { handoffToken?: string };
      message?: string;
    }>(
      '/v1/studio/launch',
      {},
      { timeout: 15000 },
    );
    if (response.data.status === 'success' && response.data.data?.handoffToken) {
      return { ok: true, handoffToken: response.data.data.handoffToken };
    }
    return { ok: false, message: response.data.message ?? 'Failed to open Studio.' };
  } catch (error) {
    const message =
      (error as { response?: { data?: { message?: string } } }).response?.data?.message ??
      (error instanceof Error ? error.message : 'Failed to open Studio.');
    reportError(error, { source: 'studioService', operation: 'launchStudioWorkspace' });
    return { ok: false, message };
  }
}

export function redirectToStudio(handoffToken: string): void {
  markAcademyAuthResync();
  paintStudioRedirectShell();
  window.location.assign(getStudioHandoffUrl(handoffToken));
}

export const studioService = {
  launchStudioWorkspace,
  redirectToStudio,
};
